import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { StatusCard } from '@components/StatusCard';
import { Translate } from '@hooks/useI18n';
import { ManualIdentityUploadSummary } from '../types';
import { getPillLabel, getPillVariant, getStatus } from './utils';

interface IManualIdentityDocumentStatusCard {
  manualIdentityUploadSummary: ManualIdentityUploadSummary;
  translate: Translate;
}

const getHasIdBeenUploadedLabel = (
  hasUploaded: boolean | undefined,
  translate: Translate,
) =>
  translate(
    hasUploaded
      ? 'LABEL.IDENTITY_DOCUMENT_HAS_BEEN_UPLOADED'
      : 'LABEL.IDENTITY_DOCUMENT_HAS_NOT_BEEN_UPLOADED',
  );

export const ManualIdentityDocumentStatusCard = ({
  manualIdentityUploadSummary,
  translate,
}: IManualIdentityDocumentStatusCard) => {
  const {
    hasIdentityDocumentBeenUploaded,
    isManualIdentityDocumentUploadRequired,
  } = manualIdentityUploadSummary ?? {};

  return isManualIdentityDocumentUploadRequired ? (
    <StatusCard
      description={translate('LABEL.IDENTITY_DOCUMENTS_MUST_BE_UPLOADED')}
      pillLabel={getPillLabel(hasIdentityDocumentBeenUploaded, translate)}
      pillVariant={getPillVariant(hasIdentityDocumentBeenUploaded)}
      statuses={[
        {
          icon: <CloudUploadIcon />,
          label: getHasIdBeenUploadedLabel(
            hasIdentityDocumentBeenUploaded,
            translate,
          ),
          type: getStatus(hasIdentityDocumentBeenUploaded),
        },
      ]}
      title={translate('TITLE.IDENTITY_DOCUMENT_UPLOAD')}
    />
  ) : null;
};
